import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import './planSelfcare360.css';

const DEFAULT_ACTION_CARDS = [1, 2, 3];

const PageActionPlanSelfcare360 = ({ selectedEvaluation, pageNumber, prefilledActions = [] }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <div className="selfcare360-plan-action-wrap">
                        <div className="selfcare360-plan-page-title">Plan de Acción a 90 Días</div>
                        <hr className="selfcare360-plan-action-divider" />
                        <p className="selfcare360-plan-action-intro">
                            Este formulario se precarga con las acciones individuales más relevantes del plan de intervención. Úsalo como hoja de seguimiento para concretar responsables, plazos y evidencias de avance.
                        </p>

                        <div className="selfcare360-plan-action-list">
                            {DEFAULT_ACTION_CARDS.map((itemNumber, index) => {
                                const actionItem = prefilledActions[index];

                                return (
                                    <div key={itemNumber} className="selfcare360-plan-action-card">
                                        <div className="selfcare360-plan-action-card-title">
                                            {actionItem?.title || `Acción a desarrollar ${itemNumber}`}
                                        </div>
                                        <div className="selfcare360-plan-action-card-dimension">
                                            {actionItem?.dimensionLabel || 'Pendiente de priorización'}
                                        </div>

                                        {actionItem?.action ? (
                                            <div className="selfcare360-plan-action-text">{actionItem.action}</div>
                                        ) : (
                                            <div className="selfcare360-plan-action-line"></div>
                                        )}

                                        <div className="selfcare360-plan-action-meta">
                                            <div>
                                                <div className="selfcare360-plan-action-label">Fecha límite / Plazo:</div>
                                                {actionItem?.dueDate ? (
                                                    <div className="selfcare360-plan-action-meta-value">{actionItem.dueDate}</div>
                                                ) : (
                                                    <div className="selfcare360-plan-action-meta-line"></div>
                                                )}
                                            </div>
                                            <div>
                                                <div className="selfcare360-plan-action-label">Indicador de avance:</div>
                                                <div className="selfcare360-plan-action-meta-line"></div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageActionPlanSelfcare360;